//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Scroll from './scroll'
import { getData } from './js/dom'
const TITLE_HEIGHT = 30
const ANCHOR_HEIGHT = 18
export default {
    props:{
        data:{
            type:Array,
            default:[]
        }
    },
    computed:{
        shortcutList() {
            return this.data.map((group) =>{
                return group.title.substr(0,1)
            })
        },
        fixedTitle() {
            if (this.scrollY > 0){
                return ''
            }
            return this.data[this.currentIndex] ? this.data[this.currentIndex].title : ''
        }
    },
    data() {
        return {
            scrollY:-1,
            currentIndex:0,
            diff:-1
        }
    },
    created() {
        this.probeType = 3
        this.listenScroll = true
        this.touch = {}
        this.listHeight = []
    },
    methods:{
        selectItem(item) {
            setTimeout(()=>{
                this.$emit('select',item)
            },300)
        },
        onShortcutTouchStart(e) {
            let anchorIndex = getData(e.target,'index')
            let firstTouch = e.touches[0]
            this.touch.y1 = firstTouch.pageY
            this.touch.anchorIndex = anchorIndex
            this._scrollTo(anchorIndex)
        },
        onShortcutTouchMove(e) {
            let firstTouch = e.touches[0]
            this.touch.y2 = firstTouch.pageY
            let delta = (this.touch.y2 - this.touch.y1) / ANCHOR_HEIGHT | 0
            let anchorIndex = parseInt(this.touch.anchorIndex) + delta
            this._scrollTo(anchorIndex)
        },
        refresh() {
            this.$refs.listview.refresh()
        },
        scroll(pos) {
            this.scrollY = pos.y
        },
        _calculateHeight() {
            this.listHeight = []
            const list = this.$refs.listGroup
            let height = 0
            this.listHeight.push(height)
            for(let i = 0; i < list.length; i++) {
                let item = list[i]
                height += item.clientHeight
                this.listHeight.push(height)
            }
            console.log(this.listHeight)
        },
        _scrollTo(index) {
            this.currentIndex = index
            this.scrollY = -this.listHeight[index]
            this.$refs.listview.scrollToElement(this.$refs.listGroup[index],0)
        }
    },
    watch:{
        data() {
            setTimeout(() =>{
                this._calculateHeight()
            },200)
        },
        scrollY(newY) {
            const listHeight = this.listHeight
            if (newY > 0){
                this.currentIndex = 0
                return
            }
            for(let i = 0; i < listHeight.length - 1; i++) {
                let height1 = listHeight[i]
                let height2 = listHeight[i + 1]
                if (-newY >= height1 && -newY < height2){
                    this.currentIndex = i
                    this.diff = height2 + newY
                    return
                }
            }
            this.currentIndex = listHeight.length - 2
        },
        diff(newVal) {
            let fixedTop = (newVal > 0 && newVal < TITLE_HEIGHT) ? newVal - TITLE_HEIGHT : 0
            if (this.fixedTop === fixedTop){
                return
            }
            this.fixedTop = fixedTop
            this.$refs.fixed.style.transform = `translate3d(0,${fixedTop}px,0)`
        }
    },
    components:{
        Scroll
    }
}




// WEBPACK FOOTER //
// ./src/components/common/listview.vue